import { render, staticRenderFns } from "./fhir-identifier.vue?vue&type=template&id=087d5c14&"
import script from "./fhir-identifier.vue?vue&type=script&lang=js&"
export * from "./fhir-identifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports